import Pqp from "../../../3x1010/Pqp";
import Game from "../../Game";
import Maze from "../../maze/Maze";

export default class RoomDresser {
	constructor(model, cfg, sp) {
		this.model = model;
		this.cfg = cfg;
		this.sp = sp;
	}

	dress() {
		let rooms = this.model.rooms;
		for (let x = 0; x < rooms.length; x++) {
			this.dressRoom(rooms[x]);
		}
	}

	dressRoom(room) {
		let det = Game.that.featurer.getCurrentLevelDetails();
		let type = det.roomsDress.split(",")[room.roomIndex];

		if (type) {
			type = Pqp.safeReplace(type, "[", "");
			type = Pqp.safeReplace(type, "]", "");
			let types = type.split("|");
			for (let x = 0; x < types.length; x++) {
				let feat = types[x];
				if (feat === "fireplace") {
					this.addFireplace(room);
				}
			}

		}

	}

	clean(s) {
		s = Pqp.safeReplace(s, "\n", "");
		s = Pqp.safeReplace(s, "\r", "");
		return s;
	}

	addFireplace(room) {
		let cell = room.getSuitablePlaceFor("fireplace");
		this.model.statics.push({ type: Maze.STATIC_TYPE_FIREPLACE, cell: cell });
	}

	addFurnitures() {
		let rooms = this.model.rooms;
		for (let x = 0; x < rooms.length; x++) {
			this.addRoomFurniture(rooms[x], true);
			this.addRoomFurniture(rooms[x], false);
		}

	}

	addRoomFurniture(room, lUpper) {
		let det = Game.that.featurer.getCurrentLevelDetails();
		let fornitures;
		if (lUpper) {
			fornitures = this.clean(det.roomsUpperFurniture).split(",")[room.roomIndex];
		} else {
			fornitures = this.clean(det.roomsLowerFurniture).split(",")[room.roomIndex];
		}
		if (!Pqp.isNullOrEmpty(fornitures)) {
			//console.log(fornitures);
			fornitures = Pqp.safeReplace(fornitures, "[", "");
			fornitures = Pqp.safeReplace(fornitures, "]", "");
			let list = fornitures.split("|");
			for (let x = 0; x < list.length; x++) {
				this.addFurniture(room, list[x], lUpper);
			}
		}

	}

	addFurniture(room, items, lUpper) {
		let options = items.split("/");
		for (let x = 0; x < options.length; x++) {
			if (this.tryToAddFurnitureToRoom(room, options[x], lUpper)) {
				break;
			}
		}
	}

	tryToAddFurnitureToRoom(room, item, lUpper) {
		let lRet = false;
		let parm = null;
		let pos = null
		let original = item;
		if (item.indexOf("_") >= 0) {
			let tmp = item.split("_");
			//item = tmp[0];
			parm = tmp[1];
		}
		if (item.indexOf("%") >= 0) {
			let tmp = item.split("%");
			//item = tmp[0];
			pos = tmp[1];
		}
		item = item.split("_")[0];
		item = item.split("%")[0];


		//console.log("---->"+item)
		let pieces = this.sp.getFurniture(item, parm);
		if (pieces) {
			if (lUpper) {
				if (pieces.length === 4) {
					lRet = this.placeForniture4Upper(room, item, pieces, pos);
				} else if (pieces.length === 2) {
					lRet = this.placeForniture2Upper(room, item, pieces, pos);
				} else if (pieces.length === 1) {
					lRet = this.placeForniture1Upper(room, item, pieces, pos);
				}
			} else {
				if (pieces.length === 1) {
					lRet = this.placeForniture1Lower(room, item, pieces, pos);
				}
			}
		} else {
			console.log("Can't find item "+item)
		}

		return lRet;
	}

	placeForniture1Upper(room, item, pieces, pos) {
		//console.log("try 1")
		let lRet = false;
		let cells = room.cells[0];
		cells = cells.slice();
		if (pos) {
			let prefix = pos.charAt(0);
			let n = parseInt(pos.substr(1));
			let tmp;
			if (prefix === "w") {
				tmp = cells[n];
				if (tmp) {
					cells.splice(n, 1);
				}
			} else if (prefix === "e") {
				tmp = cells[cells.length - 1 - n];
				if (tmp) {
					cells.splice(cells.length - 1 - n, 1);
				}

			} else if (prefix === "c") {
				tmp = cells[Math.floor(cells.length / 2) + 1 + n];
				if (tmp) {
					cells.splice(Math.floor(cells.length / 2) + 1 + n, 1);
				}
			}
			cells = Pqp.shuffle(cells);
			if (tmp) {
				cells.unshift(tmp);
			}
		} else {
			cells = Pqp.shuffle(cells);
		}

		for (let x = 0; x < cells.length; x++) {
			let cell = cells[x];
			if (cell.isFree()) {
				// se la cella è libera
				if (this.nearbyCellsAreNotExits(cell, [Maze.DIR_N, Maze.DIR_W, Maze.DIR_E])) {
					// se le celle confinanti non sono uscite
					cell.blocked = true;
					//console.log("OK1")
					// Piazza l'item da 1
					cell.setFurniture(pieces[0], false);
					lRet = true;

					break;
				}
			}
		}
		return lRet;
	}
	placeForniture2Upper(room, item, pieces, pos) {
		//console.log("try 2")
		let lRet = false;
		let cells = room.cells[0];
		cells = cells.slice();
		if (pos) {
			let prefix = pos.charAt(0);
			let n = parseInt(pos.substr(1));
			let tmp;
			if (prefix === "w") {
				tmp = cells[n];
				if (tmp) {
					cells.splice(n, 1);
				}
			} else if (prefix === "e") {
				tmp = cells[cells.length - 1 - n];
				if (tmp) {
					cells.splice(cells.length - 1 - n, 1);
				}

			} else if (prefix === "c") {
				tmp = cells[Math.floor(cells.length / 2) + 1 + n];
				if (tmp) {
					cells.splice(Math.floor(cells.length / 2) + 1 + n, 1);
				}
			}
			cells = Pqp.shuffle(cells);
			if (tmp) {
				cells.unshift(tmp);
			}
		} else {
			cells = Pqp.shuffle(cells);
		}

		for (let x = 0; x < cells.length; x++) {
			let cell = cells[x];
			if (cell.isFree()) {
				// se la cella è libera
				if (this.nearbyCellsAreNotExits(cell, [Maze.DIR_N, Maze.DIR_W, Maze.DIR_E])) {
					// se le celle confinanti non sono uscite
					cell.blocked = true;
					//console.log("OK2")
					// Piazza l'item da 1
					cell.setFurniture(pieces[0], false);
					let n = this.model.getNearbyCell(cell, Maze.DIR_N);
					n.setFurniture(pieces[1]);

					lRet = true;

					break;
				}
			}
		}
		return lRet;
	}
	placeForniture4Upper(room, item, pieces, pos) {
		//console.log("try 4")
		let lRet = false;
		let cells = room.cells[0];
		cells = cells.slice();
		if (pos) {
			let prefix = pos.charAt(0);
			let n = parseInt(pos.substr(1));
			let tmp;
			if (prefix === "w") {
				tmp = cells[n];
				if (tmp) {
					cells.splice(n, 1);
				}
			} else if (prefix === "e") {
				tmp = cells[cells.length - 1 - n];
				if (tmp) {
					cells.splice(cells.length - 1 - n, 1);
				}

			} else if (prefix === "c") {
				tmp = cells[Math.floor(cells.length / 2) + 1 + n];
				if (tmp) {
					cells.splice(Math.floor(cells.length / 2) + 1 + n, 1);
				}
			}
			cells = Pqp.shuffle(cells);
			if (tmp) {
				cells.unshift(tmp);
			}
		} else {
			cells = Pqp.shuffle(cells);
		}

		for (let x = 0; x < cells.length; x++) {
			let cell = cells[x];
			if (cell.isFree()) {
				// se la cella è libera
				if (this.nearbyCellsAreNotExits(cell, [Maze.DIR_N, Maze.DIR_W, Maze.DIR_E])) {
					// se le celle confinanti non sono uscite
					let e = this.model.getNearbyCell(cell, Maze.DIR_E);
					if (e.isFree()) {
						// Se la celle confinanti con la cella a destra non sono uscite
						if (this.nearbyCellsAreNotExits(e, [Maze.DIR_N, Maze.DIR_E])) {
							cell.blocked = true;
							e.blocked = true;
							//console.log("OK4")

							// Piazza il mobile da 4
							cell.setFurniture(pieces[0], false);
							e.setFurniture(pieces[1]);
							let n = this.model.getNearbyCell(cell, Maze.DIR_N);
							n.setFurniture(pieces[2]);
							let en = this.model.getNearbyCell(e, Maze.DIR_N);
							en.setFurniture(pieces[3]);
							lRet = true;

							break;
						}
					}
				}
			}
		}
		return lRet;
	}

	placeForniture1Lower(room, item, pieces, pos) {
		//console.log("try 1")
		//console.log("pos",pos)
		let lRet = false;
		let cells = room.cells[room.cells.length - 1];
		cells = cells.slice();
		if (pos) {
			let prefix = pos.charAt(0);
			let n = parseInt(pos.substr(1));
			//console.log("->"+n);
			let tmp;
			if (prefix === "w") {
				tmp = cells[n];
				if (tmp) {
					cells.splice(n, 1);
				}
			} else if (prefix === "e") {
				tmp = cells[cells.length - 1 - n];
				if (tmp) {
					cells.splice(cells.length - 1 - n, 1);
				}

			} else if (prefix === "c") {
				tmp = cells[Math.floor(cells.length / 2)  + n];
				if (tmp) {
					cells.splice(Math.floor(cells.length / 2)  + n, 1);
				}
			}
			cells = Pqp.shuffle(cells);
			if (tmp) {
				cells.unshift(tmp);
			}
		} else {
			cells = Pqp.shuffle(cells);
		}

		for (let x = 0; x < cells.length; x++) {
			let cell = cells[x];
			if (cell.isFree()) {
				// se la cella è libera
				if (this.nearbyCellsAreNotExits(cell, [Maze.DIR_S, Maze.DIR_W, Maze.DIR_E])) {
					// se le celle confinanti non sono uscite e non è nelle immediate vicinanze di un'uscita
					let e = this.model.getNearbyCell(cell, Maze.DIR_E);
					if (this.nearbyCellsAreNotExits(e, [Maze.DIR_S])) {
						let w = this.model.getNearbyCell(cell, Maze.DIR_W);
						if (this.nearbyCellsAreNotExits(w, [Maze.DIR_S])) {
							cell.blocked = true;
							//console.log("OK1")
							// Piazza l'item da 1
							cell.setFurniture(pieces[0], true);
							lRet = true;
							break;
						}
					}
				}
			}
		}
		return lRet;
	}



	nearbyCellsAreNotImportants(cell, dirs) {
		for (let x = 0; x < dirs.length; x++) {
			let dir = this.model.getNearbyCell(cell, dirs[x]);
			if (!dir.isNotImportant()) {
				return false;
			}
		}
		return true;
	}
	nearbyCellsAreNotExits(cell, dirs) {
		if (!cell) {
			return true;
		}
		for (let x = 0; x < dirs.length; x++) {
			let dir = this.model.getNearbyCell(cell, dirs[x]);
			if (dir) {
				if (dir.isRoomExit()) {
					return false;
				}
				if (dir.end) {
					return false;
				}
				if (dir.start) {
					return false;
				}
			}

		}
		return true;
	}


}